










































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnFormTitle } from '@/components/';
import { namespace } from 'vuex-class';
import { AcgnPop } from '@acgn/herm/src/ui';
import { setDateTimeStamp } from '@acgn/herm/src/util/time';
import { Link, Image } from 'element-ui';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
} from '@acgn/herm/src/ui';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const CommGetter = namespace('desk/comm').Getter;
const AuthGetter = namespace('desk/auth').Getter;
@Component({
  components: {
    AcgnTable,
    AcgnPop,
    AcgnFormTitle,
    [Link.name]: Link,
    [Image.name]: Image
  }
})

/**
 * 审批详情弹框
 */
export default class AcgnApprovalDetail extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public linkId: any; // 环节id
  @Prop({default: 0}) public instanceId: any; // 详情id
  @Prop() public downCode: any; // 授权码
  @TaskGroupAction private getlistByLinkid: any;  // 审批列表
  @TaskGroupAction private getDetailByid: any;  // 审批详情
  @CommGetter private attributeData: any; // 公共类型
  @AuthGetter private userInfo: any;
  private isDetail: any = false;
  private approList: any = [];
  private cellNumber: any = '';
  private approDetail: any = {};
  private comicMessage: any = {};
  private visibleCell: any = false;
  private defaultUserImage: string = 'https://activity-resource.oss-cn-hangzhou.aliyuncs.com/h5_activity_product/icon/user_img.jpeg'; // 默认头像
  private otherInfo: any = {}; // 默认头像

  @Watch('visible',  {deep: true})
  private async linkAppro() {
    if (this.instanceId) {
      this.getDetail(this.instanceId);
      return false;
    }
    if (this.linkId) {
      const { result } = await this.getlistByLinkid({ link_id: this.linkId });
      this.comicMessage = result.other_info;
      this.approList = result.instance_info;
      this.otherInfo = result.other_info;
      if (result.instance_info.length === 1) {
        this.getDetail(result.instance_info[0].id);
        return false;
      }
    }
  }
  // 提交
  private submit() {
    this.$emit('update:visible', false);
  }

  // 编辑件数
  private editCellNumber() {
    this.visibleCell = true;
  }

  // 提交件数
  private async submitCell() {
    // console.log(this.approDetail);
    // const date = this.setDateTimeStamp(this.data.over_submit_time);
    // const params = {
    //   link_id: this.data.id,
    //   cell_number: this.cellNumber,
    //   over_submit_time: getDateTimeStamp(date , 'YYYY-MM-DD HH:mm:ss')
    // };
    // await this.editLinkInfo(params);
    // this.refresh();
    // this.$message.success('保存成功');
    // this.visible = false;
  }

  // 获取审批详情
  private async getDetail(id: any) {
    const { result } = await this.getDetailByid({ instance_id: id });
    this.approDetail = result;
    this.isDetail = true;
  }

  // 格式化时间
  private setDateTimeStamp(str: any) {
    return setDateTimeStamp(str, 'YYYY-MM-DD HH:mm:ss');
  }

  // 神评状态列表内部
  private get statusNameIn() {
    return this.attributeData.other_type[0];
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.instance_status;
  }

  private close() {
    this.visibleCell = false;
  }

  // 图片src
  private getImageListStr(item: any) {
    return `${(window as any).configs.imageDomain + item}`;
  }
  // 图片列表
  private getImageList(item: any) {
    return [`${(window as any).configs.imageDomain + item}`];
  }

  // 附件下载地址
  private getFileList(item: any) {
    const str = item.toString();
    if (str.startsWith('http://') || str.startsWith('https://') ) {
      return str.replace('http://', 'https://');
    }
    return `${(window as any).configs.imageDomain + item}`;
    // return item;
  }

  // 逾期 审批
  private get statusOverdue() {
    return this.attributeData.other_type[1][1].name;
  }

  // 逾期 提交
  private get statusSubmit() {
    return this.attributeData.other_type[2][1].name;
  }

  // 审批状态
  private instanceStatus(str: any) {
    return this.statusName[str - 1].name;
  }

  // 审批状态内部
  private instanceStatusIn(str: any) {
    return this.statusNameIn[str - 1].name;
  }

  // 审批状态
  private instanceClass(str: any) {
    switch (str) {
      case 1:
      case 2:
        return 'color--warning';
      case 3:
        return 'color--danger';
      case 4:
        return 'color--success';
      case 5:
        return 'color--danger';
    }
  }

  get show() {
    return this.visible;
  }
  set show(v) {
    this.$emit('update:visible', v);
    this.isDetail = false;
  }

  // 审批状态样式
  private getStaClass(status: any) {
    switch (status) {
      case 1:
        return 'acgn-succ';
      case 2:
        return 'acgn-ing';
      case 3:
        return 'acgn-refuse';
      case 4:
        return 'acgn-pass';
      case 5:
        return 'acgn-succ';
    }
  }

  // 审批状态列表
  private get statusNameUser() {
    return this.attributeData.other_type[9];
  }

  // 审批节点状态
  private getAppSta(sta: any) {
    return `（${this.statusNameUser[sta - 1].name}）`;
  }

  private get isSubmitUser() {
    if (this.approDetail.main) {
      return parseInt(this.approDetail.main[0].origin_uid, 10) === this.otherInfo.submit_user_id;
    } else {
      return false;
    }
  }
}
